import React from 'react'

export default function ReportTypeRestrictions({ reportTypeRestriction, setSelectedPermission, loader, allRoles }) {
    // const handleReportTypeRestrictionCheckbox = (e, index, role) => {
    //     let reportTypeRestrictionArray = [...reportTypeRestriction]
    //     reportTypeRestrictionArray[index][role] = e.target.checked ? "true" : "false"
    //     setSelectedPermission(reportTypeRestrictionArray)
    // }
    const handleReportTypeRestrictionCheckbox = (e, entityTypeIndex, roleId) => {
        const updatedRestrictions = { ...reportTypeRestriction };

        const selectedEntityType = updatedRestrictions.all_entity_types[entityTypeIndex];

        // Find the specific role in dataset_roles
        const roleIndex = selectedEntityType.dataset_roles.findIndex(
            (role) => role.role_id === roleId
        );

        if (roleIndex !== -1) {
            selectedEntityType.dataset_roles[roleIndex].access = e.target.checked ? 1 : 0;
        }

        console.log("updatedRestrictions", selectedEntityType);
        // Update the state
        setSelectedPermission(updatedRestrictions);
    };


    return (
        <div className="p-4">
            <div className="bg-white shadow rounded-2xl p-5 overflow-x-auto">
                {loader ?
                    <div className="h-[400px] flex items-center justify-center">
                        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-primary-600"></div>
                    </div>
                    :
                    reportTypeRestriction ?
                        <>
                            <div className='flex justify-between'>
                                <div>
                                    <h2 className='font-semibold'>{reportTypeRestriction?.dataset_name}</h2>
                                    <p className='text-[15px] text-[#717576]'>{reportTypeRestriction?.description}</p>
                                </div>
                            </div>
                            <div>
                                <ul className=' border border-[#F4F4F4] mt-4'>
                                    {reportTypeRestriction?.all_entity_types?.length > 0 && reportTypeRestriction?.all_entity_types?.map((item, index) => {
                                        return (
                                            <li key={index} className='flex justify-between p-4 border-b border-b-[#F4F4F4] w-full'>
                                                <div className='w-1/2'>
                                                    <h3 className='font-bold text-[15px] text-[#283C50]'>{item.type_name}</h3>
                                                    <p className='text-[15px] text-[#717576]'>{item.reportDescription}</p>
                                                </div>
                                                <div className='flex justify-evenly w-1/2'>
                                                    {(allRoles && allRoles.length > 0) &&
                                                        allRoles.map((roleItem, ind) => {

                                                            return (
                                                                <div className='content-center'>
                                                                    <label className='flex items-center gap-2 text-[15px] text-[#283C50] cursor-pointer' key={ind}>
                                                                        <input type='checkbox' className='h-4 w-4'
                                                                            // value={roleItem?.role_id}
                                                                            onChange={(e) => handleReportTypeRestrictionCheckbox(e,
                                                                                index,
                                                                                roleItem.role_id)}
                                                                            checked={item.dataset_roles.find((role) => role.role_id === roleItem.role_id && role.access == 1)
                                                                            }
                                                                        />
                                                                        {roleItem?.role_name}
                                                                    </label>
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </div>
                                            </li>
                                        )
                                    })}
                                </ul>
                            </div>
                        </>
                        :
                        <div className="text-center h-[400px] content-center">
                            <p className="text-gray-400 text-sl">There are currently no report type.</p>
                        </div>
                }
            </div >
        </div >
    )
}
